module.exports = __webpack_public_path__ + "img/stripeBadge.a4389fdb.png";